/***       invoiceRecordMod        ***/
<template>
  <div class="invoiceRecordMod">
    <div class="page clear page1">
      <div class="title">
        <i class="iconfont icon-shijian1"></i>
      </div>
      <div class="val" style="color: #333;font-size: 1.1rem">
        {{timeFn}}
      </div>
      <div class="status" :class="stateFn==='待开'?'statusShow':''">
        {{stateFn}}
        <span class="iconfont icon-jiantou"></span>
      </div>
    </div>
    <div class="page clear page2">
      <div class="title">
      </div>
      <div class="val" style="font-size: 1.2rem">
        {{type}}
      </div>
    </div>
    <div class="page clear page3">
      <div class="title">
      </div>
      <div class="val" style="font-size: 1.2rem">
        {{memo}}
      </div>
      <div class="sum">
        {{sum}}<span style="font-size: 1rem;margin-left: .2rem">元</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import Toucth from '../../../../assets/js/method'

  export default {
    components: {},
    name: 'xk-invoiceRecordMod',
    props: ['time', 'sum', 'memo', 'state', 'type'],
    computed: {
      ...mapGetters({}),
      timeFn: function () {
        // return Toucth.TimestampDate(this.$props.time)
        return this.$props.time
      },
      stateFn: function () {
        let state = ''
        if (this.$props.state === 0) {
          state = '待开'
        }
        if (this.$props.state === 1) {
          state = '已开'
        }
        return state !== '' ? state : ''
      }
    },
    data () {
      return {}
    },
    watch: {},
    methods: {},
    mounted: function () {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .invoiceRecordMod {
    box-sizing: border-box;
    width: 100%;
    padding: 1rem;
    background: #fff;
    margin-bottom: 1rem;
    border-radius: 0.333rem;
    .page {
      line-height: 2.2rem;
      .title {
        float: left;
        color: #333;
        margin-right: 0.5rem;
        width: 1rem;
        line-height: 1.7rem;
        height: 2.2rem;
        font-size: 1.8rem;
        .icon-shijian1 {
          color: #c5c5c5;
          font-size: 1rem;
        }
      }
      .val {
        color: #999;
        float: left;
        line-height: 2.2rem;
        height: 2.2rem;
        font-size: 1rem;
        width: calc(~'100% - 10rem');
      }
      .status {
        color: #999;
        width: 3.4rem;
        float: right;
        height: 2.2rem;
        .icon-jiantou {
          font-size: 1rem;
          color: #9a9a9a;
        }
      }
      .sum {
        float: right;
        height: 2.2rem;
        font-size: 2rem;
        color: #333;
      }
      .statusShow {
        color: #f06553;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// invoiceRecordMod.vue?40324490